import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "form-block text-area" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "d-inline-block ml-2" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "d-inline-block ml-2" }
const _hoisted_6 = {
  key: 2,
  class: "action-button"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-pencil-alt" })
], -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("label", null, _toDisplayString(_ctx.data.title), 1),
    (_ctx.data.select_values)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data.select_values, (option, optionIndex) => {
            return (_openBlock(), _createBlock("div", { key: optionIndex }, [
              _withDirectives(_createVNode("input", {
                type: "checkbox",
                id: "vehicle1",
                name: "vehicle1",
                value: option.text,
                "onUpdate:modelValue": ($event: any) => (option.selected = $event)
              }, null, 8, ["value", "onUpdate:modelValue"]), [
                [_vModelCheckbox, option.selected]
              ]),
              _createVNode("label", _hoisted_3, _toDisplayString(option.text), 1)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.data.options)
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data.options, (option, optionIndex) => {
            return (_openBlock(), _createBlock("div", { key: optionIndex }, [
              _withDirectives(_createVNode("input", {
                type: "checkbox",
                id: "vehicle1",
                name: "vehicle1",
                value: option.option,
                "onUpdate:modelValue": ($event: any) => (option.selected = $event)
              }, null, 8, ["value", "onUpdate:modelValue"]), [
                [_vModelCheckbox, option.selected]
              ]),
              _createVNode("label", _hoisted_5, _toDisplayString(option.option), 1)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.editStatus)
      ? (_openBlock(), _createBlock("div", _hoisted_6, [
          _hoisted_7,
          _hoisted_8
        ]))
      : _createCommentVNode("", true)
  ]))
}